exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fb-login-button{padding:10px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/lib/auth/auth-form/auth-facebook.component.styl
// module id = 833
// module chunks = 0